import * as actionTypes from './excelActionTypes';

const initialState = {
    processedExcel: null,
    transforming: false
}

export default function user(state = initialState, action) {
    switch (action.type) {
        case (actionTypes.PROCESSED_EXCEL):
            if (state.processedExcel !== action.processedExcel) {
                return Object.assign({}, state, { processedExcel: action.processedExcel });
            }
            return state;
        case (actionTypes.TRANSFORMING):
            if (state.transforming !== action.transforming) {
                return Object.assign({}, state, { transforming: action.transforming });
            }
            return state;
        default:
            return state;
    }
}